module.exports = __webpack_public_path__ + "static/media/MealDetailsBlue.0fa7edf8.svg";